import i18n from "@/libs/i18n";

const fields = [
    {
        key: 'name',
        label: i18n.t('name'),
    },
    {
        key: 'email',
        label: i18n.t('Email'),
    },
    {
        key: 'verified',
        label: i18n.t('verified'),
    },
    {
        key: 'action',
        label: i18n.t('action'),
    },
]

export default fields